import React, { FC, useContext } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import styles from './SideMenu.module.scss';
import { v4 as uuid } from 'uuid';
import { Tooltip } from 'esa-ui-library';
import { useStore, PropertyType } from '../../../common';
import { AuthContext } from '../../../logic';

interface SideMenuProps {
	options: PropertyType[];
	title?: string;
}

const SideMenu: FC<SideMenuProps> = ({ options, title }): JSX.Element => {
	const [{ userId, username }] = useStore();
	const { user } = useContext(AuthContext);
	const history = useHistory();
	const location = useLocation();
	const isCurrentUser = user?.id === userId;

	const isItemActive = (val: string) => location.pathname.includes(val);

	const onOptionClick = (i: PropertyType) => {
		history.push(`${i.value}${userId ? `/${userId}` : ''}`);
	};

	const getOptionTestId = (label: string) => `${label.replace(/ /g, '-').toLowerCase()}-option`;

	const renderOptions = () => (
		<ul className={styles.Options}>
			{options.map((o) => (
				<li
					className={`${styles.Option} ${isItemActive(o.value) ? styles.Active : ''}`}
					onClick={() => onOptionClick(o)}
					data-testid={getOptionTestId(o.label)}
					key={uuid()}
				>
					{o.label}
				</li>
			))}
		</ul>
	);

	return (
		<nav className={styles.SideMenu}>
			{title && (
				<section className={styles.TitleSection}>
					<Tooltip text={title}>
						<h3 className={styles.Title}>{title}</h3>
					</Tooltip>
				</section>
			)}
			{!title && (
				<section className={styles.TitleSection}>
					{isCurrentUser ? (
						<h3>My account</h3>
					) : (
						<Tooltip className={styles.TitleTooltip} text={username} position='right'>
							<h3 className={styles.Title}>{username}</h3>
						</Tooltip>
					)}
				</section>
			)}
			{options && renderOptions()}
		</nav>
	);
};

SideMenu.propTypes = {
	title: PropTypes.string,
};

export { SideMenu };
